
const digest = 'a6409a4071ad2da46fd89cbc79e5189af257a5c73a7dac0c1c76c02edf4538ad';
const css = `._labelPill_15r39_1 {
  --pill-border-radius: var(--spacer-1);
  --pill-padding-inline: var(--spacer-2);
  --pill-margin-inline: var(--spacer-1);

  border: 1px solid;
  border-radius: var(--pill-border-radius);
  text-transform: uppercase;
  font-weight: bold;
  font-size: 0.9em;
  text-align: center;
  padding: 0 var(--pill-padding-inline);
  margin: 0 var(--pill-margin-inline);
}

._gray_15r39_16 {
  background-color: var(--theme-tertiary-background);
  border-color: var(--theme-primary-border);
  color: var(--theme-primary-text);
}

._blue_15r39_22 {
  background-color: var(--theme-blue-background);
  border-color: var(--theme-blue-border);
  color: var(--theme-blue-text);
}

._green_15r39_28 {
  background-color: var(--theme-green-background);
  border-color: var(--theme-green-border);
  color: var(--theme-green-text);
}

._yellow_15r39_34 {
  background-color: var(--theme-yellow-background);
  border-color: var(--theme-yellow-border);
  color: var(--theme-yellow-text);
}

._red_15r39_40 {
  background-color: var(--theme-red-background);
  border-color: var(--theme-red-border);
  color: var(--theme-red-text);
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"labelPill":"_labelPill_15r39_1","gray":"_gray_15r39_16","blue":"_blue_15r39_22","green":"_green_15r39_28","yellow":"_yellow_15r39_34","red":"_red_15r39_40"};
export { css, digest };
  